import { useEffect, useState } from 'react';
import _organizationRepository from '../services/localDBService/organizationRepository';
import _othersSelector from '@app/redux/others/selector';
import { useSelector } from 'react-redux';
import _stringUtils from '@app/utils/string.utils';
import { FK_LAM_TRON_SO_TYPE } from '@app/constants/foodkid.const';

export const useSchoolSetting = () => {
    const [list, setList] = useState();

    const fetchData = async () => {
        const data = await _organizationRepository.getAll();
        setList(data);
    };
    useEffect(() => {
        fetchData();
    }, []);

    return list;
};

export const useSchoolSettingByField = (fieldName) => {
    const [value, setValue] = useState({
        success: false,
        isLoading: true,
        data: '',
    });

    const schoolInfo = useSelector(_othersSelector.schoolInfo);

    const getData = async () => {
        if (_stringUtils.isEmpty(fieldName)) {
            setValue((prevState) => ({
                ...prevState,
                isLoading: false,
                success: false,
            }));
            return;
        }

        setValue((prevState) => ({
            ...prevState,
            isLoading: false,
            success: true,
            data: schoolInfo[fieldName],
        }));
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldName, schoolInfo]);

    return value;
};

export const useFkLamTronSo = () => {
    /**
     * 0: chưa lấy được setting
     * 1: làm tròn từng nhóm 0 số sau phần thập phân
     * 2: Hiển thị chi tiết 2 số sau phần thập phân
     */
    const [value, setValue] = useState({ decimal: 0, type: 0 });
    const { success, isLoading, data } =
        useSchoolSettingByField('fk_lam_tron_so');

    useEffect(() => {
        if (isLoading) return;
        if (!success) return;
        if (_stringUtils.isEmpty(data)) {
            setValue({ decimal: 0, type: 1 });
            return;
        }

        switch (+data) {
            case 1: {
                setValue({
                    decimal: 0,
                    type: FK_LAM_TRON_SO_TYPE.TUNG_NHOM_DECIMAL_0,
                });
                break;
            }
            case 2: {
                setValue({
                    decimal: 2,
                    type: FK_LAM_TRON_SO_TYPE.TUNG_NHOM_DECIMAL_2,
                });
                break;
            }
            case 3: {
                setValue({
                    decimal: 2,
                    type: FK_LAM_TRON_SO_TYPE.TONG_NHOM_DECIMAL_0,
                });
                break;
            }
            default: {
                break;
            }
        }
    }, [success, isLoading, data]);

    return value;
};
